<div class="box">
  <div class="onetimepay-detail-card">
    <!-- first column for account info -->
    @if (accounts?.length > 1) {
      <div class="onetimepay-detail-card-left">
        <div class="onetimepay-detail-card-left-item-container">
          <div class="onetimepay-detail-card-item-block">
            <span class="bill-account-icon icon-online-billing"></span>
          </div>
          <div class="onetimepay-detail-card-item-block">
            <p dsContent [contentPath]="'shared.bundledPayment'"></p>
            <p class="onetimepay-detail-card-item-caption">{{ accounts.length }} accounts</p>
          </div>
        </div>
      </div>
    }
    @if (accounts?.length === 1) {
      <div class="onetimepay-detail-card-left">
        <div class="onetimepay-detail-card-item-container">
          <div class="onetimepay-detail-card-item-block">
            <span
              class="pseudo-icon bill-account-icon"
              [ngClass]="accounts[0].policyTypeIcon"
            ></span>
          </div>
          <div class="onetimepay-detail-card-item-block">
            <p>{{ accounts[0].riskDescription }}</p>
            <p class="onetimepay-detail-card-item-caption">{{ accounts[0].billAccountNumber }}</p>
          </div>
        </div>
      </div>
    }

    <div class="onetimepay-detail-card-right">
      <!-- second column for total ammount -->
      <div class="onetimepay-detail-card-right-item-container">
        <p>{{ accounts[0].paymentAmount | currencyUSD }}</p>
        <p>{{ accounts[0].paymentDate }}</p>
      </div>
      <!-- third column for payment method -->
      <div class="onetimepay-detail-card-right-item-container">
        <ds-payment-method-block
          [rowExpanded]="false"
          [useNickNameAsTitle]="accounts[0].useNickNameAsTitle"
          [paymentAccount]="accounts[0].paymentAccount"
        ></ds-payment-method-block>
        <p [ngClass]="{ warning: errorItem?.warning }">{{ errorItem?.text }}</p>
      </div>
    </div>
  </div>
</div>
